/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import {
  chooseUploadReport,
  endCreateModelFlow,
  leaveCreateModelFlowStep,
} from '#actions/models/createModelFlow.js';
import UploadDecisionStep from './UploadDecisionStep.jsx';

const mapDispatchToProps = { chooseUploadReport, endCreateModelFlow, leaveCreateModelFlowStep };

export default pipe(
  connect(null, mapDispatchToProps),
  withNavigate,
  withRouteParams
)(UploadDecisionStep);
